<template>
  <v-card color="primary" class="ui-module-card">
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              :value="cursoPersonal.ProgramacionCurso.Subcategoria.subcategoria"
              rounded
              readonly
              filled
              dense
              background-color="transparent"
              color="secondary"
              label="Curso realizado"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 font-weight-bold">Categoría</div>
            <div class="text-subtitle-2">
              {{ cursoPersonal.ProgramacionCurso.Subcategoria.CatCategoria.categoria }}
            </div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 font-weight-bold">Tipo</div>
            <div class="text-subtitle-2">
              {{ cursoPersonal.ProgramacionCurso.Subcategoria.CatCategoria.CatTipoCurso.title }}
            </div>
          </v-col>
          <v-col cols="6">
            <div class="text-subtitle-2 font-weight-bold">Asistió</div>
            <v-icon v-if="cursoPersonal.asistencia == 1" color="success">mdi-check</v-icon>
            <v-icon v-else color="error">mdi-close-circle</v-icon>
          </v-col>
          <v-col cols="6">
            <div class="text-subtitle-2 font-weight-bold">Calificación</div>
            <div class="text-subtitle-2" v-if="cursoPersonal.calificacion.length > 0">
              {{ cursoPersonal.calificacion }}
            </div>
            <div class="text-subtitle-2" v-else>No asignada</div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 font-weight-bold">Comentarios</div>
            <div class="text-subtitle-2" v-if="cursoPersonal.comentario.length > 0">
              {{ cursoPersonal.comentario }}
            </div>
            <div class="text-subtitle-2" v-else>Ninguno</div>
          </v-col>
          <v-col cols="12" align="right">
            <v-text-field
              :value="calificacionEvaluacion"
              @input="updateCalificacionEvaluador($event)"
              :rules="[(v) => (v >= 0 && v <= 10) || 'La calificación debe estar entre 0 y 10']"
              label="Calificación a evaluador"
              type="number"
              min="0"
              max="10"
              rounded
              filled
              dense
              background-color="transparent"
              color="secondary"
            />
            <TextButton :loading="loading" :disabled="loading" @click="updateEvaluacion">Guardar</TextButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import TextButton from '../base/TextButton.vue'

export default {
  components: {
    TextButton,
  },

  props: {
    cursoPersonal: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    this.calificacionEvaluacion = this.cursoPersonal.calificacionEvaluacion ?? 0
  },

  data() {
    return {
      calificacionEvaluacion: 0,
      loading: false,
    }
  },

  methods: {
    ...mapActions('cursoAsignado', ['updateAsignacionCursosPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    updateCalificacionEvaluador(value) {
      const parsedValue = Number(value)

      if (parsedValue > 0 && parsedValue <= 10) {
        this.calificacionEvaluacion = parsedValue
      }
    },

    async updateEvaluacion() {
      try {
        this.loading = true
        const payload = {
          ...this.cursoPersonal,
          calificacionEvaluacion: String(this.calificacionEvaluacion),
        }
        await this.updateAsignacionCursosPersonal([payload])
        this.SET_SNACKBAR_MESSAGE('Calificación asignada correctamente')
      } catch {
        this.SET_SNACKBAR_MESSAGE('Error al asignar la calificación')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}
</style>
